import { FormControl, ValidatorFn } from '@angular/forms';

interface CustomValidator {
    [error: string]: {
        errorLabel: string
    };
}

/**
 * Extract only hexadecimal characters from the input string.
 * @param inputString The string from which to extract the characters.
 */
function getHexCharacters(inputString: string): string {
    if (!inputString) {
        return;
    }
    const hexMatcher = /[0-9A-Fa-f]/g;
    const matchedArray = inputString.match(hexMatcher);
    return matchedArray && matchedArray.join('');
}

export class CustomValidators {

    static blankField = (fieldName?: string): ValidatorFn => {
        // Checks if form control contains only whitespace
        const pattern = /^\s+$/;
        fieldName = fieldName ? fieldName : 'Field';
        return (control: FormControl): CustomValidator => {
            if (control.value && !!control.value.match(pattern)) {
                return {
                    'isBlank': {
                        errorLabel: `${fieldName} cannot be blank`
                    }
                };
            }
        };
    }

    static pattern = (regExp: RegExp, errorLabel?: string) => {
        errorLabel = errorLabel ? errorLabel : 'Enter valid input';
        return (control: FormControl): CustomValidator => {
            if (control.value && !regExp.test(control.value)) {
                return {
                    'pattern': {
                        errorLabel: errorLabel
                    }
                };
            }
        };
    }

    static trailingSpace = (errorLabel?: string) => {
        const regExp = /^(?! ).*(?<! )$/
        errorLabel = errorLabel ? errorLabel : 'No trailing spaces'
        return (control: FormControl): CustomValidator => {
            if (control.value && !regExp.test(control.value)) {
                return {
                    'trailingSpace': {
                        errorLabel: errorLabel
                    }
                };
            }
        };
    }

    static trailinghypen = (errorLabel?: string) => {
        const regExp = /^(?![0-9]+$)[\s\S]*[^-]$/
        errorLabel = errorLabel ? errorLabel : 'Trailing hyphen is not allowed'
        return (control: FormControl): CustomValidator => {
            if (control.value && !regExp.test(control.value)) {
                return {
                    'trailinghypen': {
                        errorLabel: errorLabel
                    }
                };
            }
        };
    }

    static macAddress = (control: FormControl): CustomValidator => {
        const formattedMac = getHexCharacters(control.value);
        if (!formattedMac || formattedMac.length !== 12) {
            return {
                'invalidMacAddress': {
                    errorLabel: 'Invalid entry. Enter 12 hexadecimal characters.'
                }
            };
        }
    }

    static invalidReasonCheck = () => {
        const regExp = /^[^a-zA-Z]*system generated entry[^a-zA-Z]*$/i;
        return (control: FormControl): CustomValidator => {
            if (control.value && regExp.test(control.value)) {
                return {
                    'invalidReason': {
                        errorLabel: `'${control.value}' is not allowed as the reason`
                    }
                };
            }
        };
    }

    static maxLength = (max: number, errorLabel?: string): ValidatorFn => {
        errorLabel = errorLabel || `Maximum ${max} characters allowed`;
        return (control: FormControl): CustomValidator => {
            if (control.value && control.value.length > max) {
                return {
                    'maxLength': {
                        errorLabel: errorLabel
                    }
                };
            }
        };
    }
}
